
import Filler from "./Filler";

import classes from "./ProgressBar.module.css";

const ProgressBar = (props) => {
  return (
    <div className={classes.progressbar}>
      <Filler percentage={props.percentage} />
    </div>
  );
};

export default ProgressBar;
